import {
  collection,
  query,
  where,
  getDocs,
  doc,
  setDoc,
  deleteDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";

export async function linkUserIfInvited(user) {
  const uid = user.uid;
  const email = user.email.toLowerCase().trim();

  // 1. Look for invite with matching email and no clientUid
  const inviteQuery = query(
    collection(db, "linkedClients"),
    where("clientEmail", "==", email),
    where("clientUid", "==", null)
  );
  const snap = await getDocs(inviteQuery);

  if (snap.empty) {
    console.log("❌ No pending invite found for:", email);
    return false;
  }

  const inviteDoc = snap.docs[0];
  const data = inviteDoc.data();

  // 2. Delete old invite first
  await deleteDoc(inviteDoc.ref);

  // 3. Create UID-based doc in linkedClients
  const newRef = doc(db, "linkedClients", uid);
  await setDoc(newRef, {
    ...data,
    clientUid: uid,
    acceptedAt: serverTimestamp(),
  });

  // 4. Create user doc if not already created
  const userDocRef = doc(db, "users", uid);
  await setDoc(
    userDocRef,
    {
      email,
      createdAt: serverTimestamp(),
      plan: "free",
      trialStartedAt: serverTimestamp(),
      source: "web",
      accountantUid: data.accountantUid,
    },
    { merge: true } // ✅ prevents overwriting if already exists
  );

  console.log("✅ Invite accepted & user linked:", uid);
}
